import React from 'react'
import { Link } from 'react-router-dom'
import Vector2 from "../assets/signup/Vector2.png";
import { Input } from 'antd';
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import { AppleFilled, EyeInvisibleOutlined, EyeTwoTone, GoogleOutlined } from '@ant-design/icons';
import Navbar from '../components/Navbar';

const ForgotPassword = () => {
  return (
    <>
      <Navbar />
      <div className='px-20 max-lg:px-5 grid grid-cols-2 max-lg:grid-cols-1 gap-10 lg:items-center relative pb-7 my-14'>
        <div>
          <h1 className="text-[#14294F] text-4xl mt-10 max-lg:mt-0 max-lg:text-2xl max-lg:text-center font-bold leading-relaxed mx-auto">
            RECOVER YOUR <br />
            ACCOUNT HERE
          </h1>
          <img src={Vector2} className="w-[580px] h-[260px] absolute left-40 top-5 z-10 max-lg:hidden" />
          <p className="text-[#14294F] text-lg mt-40 max-lg:mt-10 w-1/2 mx-auto text-center">Already on Samoolah? <Link to="/signup" className="text-[#FE9B71]">SIGN IN</Link></p>
        </div>
        <div className='bg-[#FCFBFA] rounded-2xl pb-5'>
          <h3 className="text-[#14294F] text-2xl font-bold mt-5 leading-relaxed mx-auto text-center">
            Forgot Password
          </h3>

          <form className="my-5 mx-7 max-lg:mx-3">
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">
              <div>
                <p className="text-[#283D63] text-center">
                  Email <span className="text-[#CC0F0F]">*</span>
                </p>
                <Input
                  placeholder="Eg. Solimannhene16@gmail.com"
                  suffix={<img src={mail} className="w-[20px]" />}
                  className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                />
              </div>
              <button className="bg-[#FE9B71] text-white rounded-full px-14 py-3 mt-8 flex mx-auto font-semibold">
                Send reset mail
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword